import React from 'react';

/** Fixed-position cell tooltip (matches Filings / objections tables). */
export default function TableHoverTooltip({ tooltip }) {
  if (!tooltip) return null;
  return (
    <div
      className="map-hover-tooltip"
      style={{
        left: tooltip.x + 15,
        top: tooltip.y + 15,
      }}
      role="tooltip"
    >
      {tooltip.content}
    </div>
  );
}
